import { render, staticRenderFns } from "./cart-foot.vue?vue&type=template&id=49ad4482&"
import script from "./cart-foot.vue?vue&type=script&lang=js&"
export * from "./cart-foot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports